var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.MainBannerBlock.conf.enabled'
      ) == 1
    )?_c('MainBannerBlock',{attrs:{"itemData":_vm._.get(
        this.$store.state.current_content,
        'secondary.MainBannerBlock.data'
      )}}):_vm._e(),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.NewsBlock.conf.enabled'
      ) == 1
    )?_c('NewsBlock',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.NewsBlock')}}):_vm._e(),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.ProductsSlider.conf.enabled'
      ) == 1
    )?_c('ProductsSlider',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.ProductsSlider')}}):_vm._e(),(_vm._.size(this.$store.state.current_content))?_c('MoreWaysForBanking',{staticClass:"more-ways-business"}):_vm._e(),_c('section',{staticClass:"container currencies-mob"},[(
        _vm._.get(
          this.$store.state.current_content,
          'secondary.smart_block.conf.currencies'
        ) == 1
      )?_c('Currencies'):_vm._e()],1),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.TodaysOffer.conf.enabled'
      ) == 1
    )?_c('TodaysOffer',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.TodaysOffer')}}):_vm._e(),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.smart_block.conf.enabled'
      ) == 1
    )?_c('section',{staticClass:"container"},[_c('div',{staticClass:"curAndBranches mt-144 flex-box"},[(
          _vm._.get(
            this.$store.state.current_content,
            'secondary.smart_block.conf.currencies'
          ) == 1
        )?_c('Currencies'):_vm._e(),(
          _vm._.get(
            this.$store.state.current_content,
            'secondary.smart_block.conf.branches'
          ) == 1
        )?_c('Branches'):_vm._e()],1)]):_vm._e(),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.business_banner.conf.enabled'
      ) == 1
    )?_c('BusinessBanner',{attrs:{"itemData":_vm._.get(
        this.$store.state.current_content,
        'secondary.business_banner.data'
      )}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }